import { createAction } from "@shared/store/helpers";
import { LoadingType, Notification, ModalProps, OverlayProps } from "@shared/interfaces";

import { SharedActionTypes } from "./constants";

export const startLoading = createAction(SharedActionTypes.START_LOADING)();
export const stopLoading = createAction(SharedActionTypes.STOP_LOADING)();
export const addLoadingType = createAction(SharedActionTypes.ADD_LOADING_TYPE)<LoadingType>();
export const removeLoadingType = createAction(SharedActionTypes.REMOVE_LOADING_TYPE)<string>();

export const addLoadingSection = createAction(SharedActionTypes.ADD_LOADING_SECTION)<{
  loadingSection: string;
  requestName: string;
}>();
export const removeLoadingSection = createAction(SharedActionTypes.REMOVE_LOADING_SECTION)<{
  loadingSection: string;
  requestName: string;
}>();

export const showNotification = createAction(SharedActionTypes.SHOW_NOTIFICATION)<Notification>();

export const navigate = createAction(SharedActionTypes.NAVIGATE)<string>();

export const showModal = createAction(SharedActionTypes.SHOW_MODAL)<ModalProps>();
export const updateModal = createAction(SharedActionTypes.UPDATE_MODAL)<Partial<ModalProps>>();
export const hideModal = createAction(SharedActionTypes.HIDE_MODAL)();

export const showOverlay = createAction(SharedActionTypes.SHOW_OVERLAY)<OverlayProps>();
export const updateOverlay = createAction(SharedActionTypes.UPDATE_OVERLAY)<Partial<OverlayProps>>();
export const hideOverlay = createAction(SharedActionTypes.HIDE_OVERLAY)();
